export default function mapTulip(data) {
    return {
        genes: data[0].toBigNumberJs().toString(16),
        createTime: data[1].toNumber(),
        name: String(data[2]),
    };
}
